import { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import styles from './label.module.css';
import clsx from 'clsx';

export type LabelProps = React.ComponentPropsWithoutRef<'label'>;

// props.hidden visually hides label element, but still make available for screen readers
export const Label = forwardRef<HTMLLabelElement, LabelProps>(function Label(
  { className, ...rest },
  ref
) {
  const innerRef = useRef<HTMLLabelElement>(null);

  useImperativeHandle(ref, () => innerRef.current as HTMLLabelElement); // Forward innerRef
  useEffect(() => {
    const self = innerRef.current;
    const isSmall = !!self?.control?.hasAttribute('data-internal-small');
    self?.classList.toggle(styles.small, isSmall);
    return () => self?.classList.remove(styles.small);
  }, []);

  return (
    <label className={clsx(styles.label, className)} ref={innerRef} {...rest} />
  );
});
